export const DELETE_TODO = "DELETE_TODO"
export const CREATE_TODO = "CREATE_TODO"
export const DELETE_COMPLETED = "DELETE_COMPLETED"
export const CREATE_COMPLETED = "CREATE_COMPLETED"